import { createSlice } from '@reduxjs/toolkit';

export const profileSlice = createSlice({
    name: 'userProfile',
    initialState: {
        file: null,
        user_name: null
    },
    reducers: {
        addProfile: (state, action) => {
            state.file = action.payload;
        },
        addUserName: (state, action) => {
            state.user_name = action.payload;
        },
    }
})

export const { addProfile, addUserName } = profileSlice.actions;
export default profileSlice.reducer;